/*
  NordicVend: produktflikarnas skript (snippets/PRODUCT-TABS.liquid).
  Låg tidigare inline i snippeten. Som egen fil cachas den mellan sidvisningar.
  Laddas med defer från snippeten. Värden från Liquid läses från skripttaggens
  data-attribut (document.currentScript), så filen innehåller ingen Liquid.
*/
(() => {
  // Luften ovanför fliken när sidan scrollar dit: --nv-scroll-offset i layout/theme.liquid
  const NV_TAB_SCROLL_OFFSET = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nv-scroll-offset'), 10) || 96;

  const roots = document.querySelectorAll("[data-nv-product-tabs]");
  function normalizeText(str) {
    return (str || "")
      .toLowerCase()
      .replace(/\u00a0/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }
  function isSpecHeading(el) {
    return el &&
      (el.tagName === "H2" || el.tagName === "H3") &&
      normalizeText(el.textContent).includes("specifikationer");
  }
  function isDownloadHeading(el) {
    return el &&
      (el.tagName === "H2" || el.tagName === "H3") &&
      normalizeText(el.textContent).includes("nedladdningar");
  }
  function hasMeaningfulContent(el) {
    if (!el) return false;
    const text = (el.textContent || "").replace(/\s+/g, "").trim();
    const hasMedia = el.querySelector("img, a, iframe, table, ul, ol, .pdf-container, .product-flex");
    return text.length > 0 || !!hasMedia;
  }
  function lazyifyMedia(container) {
    container.querySelectorAll("img").forEach((img) => {
      if (!img.hasAttribute("loading")) img.setAttribute("loading", "lazy");
    });
    container.querySelectorAll("iframe").forEach((iframe) => {
      if (!iframe.hasAttribute("loading")) iframe.setAttribute("loading", "lazy");
    });
  }
  // Öppna och stäng en flik. Gäller både flikar från Liquid och reservbygget nedan.
  // Mjuk utfällning och stängning (19 okt 2026), som frågekorten: panelens höjd och luft animeras
  // på 0.4 s med temats kurva och innehållet tonas in. Under stängningen har fliken klassen
  // is-closing så att plustecknet vänds direkt. Minskad rörelse: öppnas och stängs direkt.
  const ACC_DUR = 400;
  const ACC_EASE = "cubic-bezier(0.28, 0.11, 0.32, 1)";
  const accReduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)");
  function setAccOpen(item, open) {
    const trigger = item.querySelector(".nv-acc-trigger");
    const panel = item.querySelector(".nv-acc-panel");
    const isOpen = item.classList.contains("is-open") && !item.classList.contains("is-closing");
    if (open === isOpen) return;
    if (trigger) trigger.setAttribute("aria-expanded", open ? "true" : "false");
    const animate = panel && panel.animate && !(accReduce && accReduce.matches);
    let fromH = null;
    if (panel && panel._nvAnim) {
      fromH = panel.getBoundingClientRect().height;
      panel._nvAnim.onfinish = null;
      panel._nvAnim.cancel();
      panel._nvAnim = null;
    }
    if (!animate) {
      item.classList.remove("is-closing");
      item.classList.toggle("is-open", open);
      return;
    }
    const cleanup = () => { panel._nvAnim = null; panel.style.overflow = ""; panel.style.boxSizing = ""; };
    panel.style.overflow = "hidden";
    panel.style.boxSizing = "border-box";
    if (open) {
      item.classList.remove("is-closing");
      item.classList.add("is-open");
      const toH = panel.getBoundingClientRect().height;
      const pad = getComputedStyle(panel).paddingBottom;
      const a = panel.animate(
        [
          { height: (fromH === null ? 0 : fromH) + "px", paddingBottom: fromH === null ? "0px" : pad, opacity: fromH === null ? 0 : 1 },
          { height: toH + "px", paddingBottom: pad, opacity: 1 }
        ],
        { duration: ACC_DUR, easing: ACC_EASE }
      );
      panel._nvAnim = a;
      a.onfinish = cleanup;
    } else {
      const startH = fromH === null ? panel.getBoundingClientRect().height : fromH;
      item.classList.add("is-closing");
      const a = panel.animate(
        [
          { height: startH + "px", opacity: 1 },
          { height: "0px", paddingBottom: "0px", opacity: 0 }
        ],
        { duration: ACC_DUR, easing: ACC_EASE, fill: "forwards" }
      );
      panel._nvAnim = a;
      a.onfinish = () => {
        item.classList.remove("is-open", "is-closing");
        a.cancel();
        cleanup();
      };
    }
  }
  function bindTrigger(item, trigger) {
    trigger.addEventListener("click", () => {
      const isOpen = item.classList.contains("is-open") && !item.classList.contains("is-closing");
      setAccOpen(item, !isOpen);
    });
  }
  let accSeq = 0;
  function createAccordionItem({ title, contentNode, open = false }) {
    accSeq += 1;
    const triggerId = "nv-acc-trigger-" + accSeq;
    const panelId = "nv-acc-panel-" + accSeq;
    const item = document.createElement("div");
    item.className = "nv-acc-item" + (open ? " is-open" : "");
    const trigger = document.createElement("button");
    trigger.type = "button";
    trigger.className = "nv-acc-trigger";
    trigger.setAttribute("aria-expanded", open ? "true" : "false");
    trigger.id = triggerId;
    trigger.setAttribute("aria-controls", panelId);
    const titleEl = document.createElement("span");
    titleEl.className = "nv-acc-title";
    titleEl.textContent = title;
    const icon = document.createElement("span");
    icon.className = "nv-acc-icon";
    icon.setAttribute("aria-hidden", "true");
    const panel = document.createElement("div");
    panel.className = "nv-acc-panel";
    panel.id = panelId;
    panel.setAttribute("role", "region");
    panel.setAttribute("aria-labelledby", triggerId);
    panel.appendChild(contentNode);
    trigger.appendChild(titleEl);
    trigger.appendChild(icon);
    bindTrigger(item, trigger);
    item.appendChild(trigger);
    item.appendChild(panel);
    return item;
  }
  roots.forEach((root) => {
    const source = root.querySelector("[data-product-description-source]");
    const stylesTarget = root.querySelector("[data-product-description-styles]");
    const target = root.querySelector("[data-product-tabs-inner]");
    // Flikarna är redan byggda i Liquid (PRODUCT-TABS): koppla bara klicken
    const built = target ? target.querySelectorAll(".nv-acc-item") : [];
    if (!source && built.length) {
      built.forEach((item) => {
        const trigger = item.querySelector(".nv-acc-trigger");
        if (trigger) bindTrigger(item, trigger);
        item.querySelectorAll(".nv-acc-content").forEach(lazyifyMedia);
      });
      return;
    }
    // Reserv: beskrivningen kunde inte delas i Liquid, bygg flikarna här
    if (!source || !stylesTarget || !target) return;
    const parser = document.createElement("div");
    parser.innerHTML = source.innerHTML || "";
    source.remove();
    Array.from(parser.querySelectorAll("style")).forEach((styleEl) => {
      stylesTarget.appendChild(styleEl.cloneNode(true));
      styleEl.remove();
    });
    let splitRoot = parser;
    const meaningfulChildren = Array.from(parser.childNodes).filter((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        return node.textContent.trim() !== "";
      }
      return true;
    });
    if (
      meaningfulChildren.length === 1 &&
      meaningfulChildren[0].nodeType === Node.ELEMENT_NODE &&
      meaningfulChildren[0].tagName !== "H2" &&
      meaningfulChildren[0].tagName !== "H3"
    ) {
      splitRoot = meaningfulChildren[0];
    }
    const topNodes = Array.from(splitRoot.childNodes).filter((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        return node.textContent.trim() !== "";
      }
      return true;
    });
    const specIndex = topNodes.findIndex((node) => {
      if (node.nodeType !== Node.ELEMENT_NODE) return false;
      if (isSpecHeading(node)) return true;
      return !!Array.from(node.querySelectorAll("h2, h3")).find(isSpecHeading);
    });
    const downloadIndex = topNodes.findIndex((node, idx) => {
      if (specIndex !== -1 && idx <= specIndex) return false;
      if (node.nodeType !== Node.ELEMENT_NODE) return false;
      if (isDownloadHeading(node)) return true;
      return !!Array.from(node.querySelectorAll("h2, h3")).find(isDownloadHeading);
    });
    /* rte: samma stil som all annan text på sajten (theme.css, sektion 129).
       Nedladdningar får den inte, där är länkarna svarta med understrykning. */
    const descBox = document.createElement("div");
    descBox.className = "nv-acc-content nv-acc-content--desc rte";
    const specBox = document.createElement("div");
    specBox.className = "nv-acc-content nv-acc-content--spec rte";
    const downloadBox = document.createElement("div");
    downloadBox.className = "nv-acc-content nv-acc-content--download";
    topNodes.forEach((node, index) => {
      const clone = node.cloneNode(true);
      if (specIndex === -1) {
        descBox.appendChild(clone);
        return;
      }
      if (index < specIndex) {
        descBox.appendChild(clone);
        return;
      }
      if (downloadIndex !== -1 && index >= downloadIndex) {
        downloadBox.appendChild(clone);
        return;
      }
      specBox.appendChild(clone);
    });
    Array.from(downloadBox.querySelectorAll("h2, h3")).forEach((h) => {
      if (isDownloadHeading(h)) h.remove();
    });
    if (!hasMeaningfulContent(downloadBox)) {
      const firstPdf = specBox.querySelector(".pdf-container");
      if (firstPdf) {
        let move = false;
        const newSpec = document.createElement("div");
        newSpec.className = "nv-acc-content nv-acc-content--spec rte";
        const newDownload = document.createElement("div");
        newDownload.className = "nv-acc-content";
        Array.from(specBox.childNodes).forEach((node) => {
          if (!move && node.nodeType === 1 && (node.matches(".pdf-container") || node.querySelector(".pdf-container"))) {
            move = true;
          }
          (move ? newDownload : newSpec).appendChild(node.cloneNode(true));
        });
        if (hasMeaningfulContent(newDownload)) {
          specBox.innerHTML = newSpec.innerHTML;
          downloadBox.innerHTML = newDownload.innerHTML;
          Array.from(downloadBox.querySelectorAll("h2, h3")).forEach((h) => {
            if (isDownloadHeading(h)) h.remove();
          });
        }
      }
    }
    Array.from(specBox.querySelectorAll("h2, h3")).forEach((h) => {
      if (isDownloadHeading(h)) h.remove();
    });
    lazyifyMedia(descBox);
    lazyifyMedia(specBox);
    lazyifyMedia(downloadBox);
    if (hasMeaningfulContent(descBox)) {
      target.appendChild(
        createAccordionItem({
          title: "Beskrivning",
          contentNode: descBox,
          open: true
        })
      );
    }
    if (hasMeaningfulContent(specBox)) {
      target.appendChild(
        createAccordionItem({
          title: "Specifikationer",
          contentNode: specBox,
          open: false
        })
      );
    }
    if (hasMeaningfulContent(downloadBox)) {
      target.appendChild(
        createAccordionItem({
          title: "Nedladdningar",
          contentNode: downloadBox,
          open: false
        })
      );
    }
  });

  // Öppnar en flik utifrån (matchar på titeln, t.ex. "Specifikationer" eller "Beskrivning")
  // och scrollar smooth så att flikens titel hamnar högst upp.
  function openAccordionItem(item) {
    if (!item) return;
    setAccOpen(item, true);
  }

  // Fliken fälls ut samtidigt som sidan glider ner, med egen mjuk kurva (window.nvSmoothScrollTo i theme.liquid)
  function scrollTitleToTop(item) {
    const trigger = item.querySelector(".nv-acc-trigger");
    if (!trigger) return;
    requestAnimationFrame(() => {
      const rect = trigger.getBoundingClientRect();
      const scrollTop = window.pageYOffset + rect.top - NV_TAB_SCROLL_OFFSET;
      if (window.nvSmoothScrollTo) {
        window.nvSmoothScrollTo(scrollTop);
      } else {
        window.scrollTo({ top: scrollTop, behavior: (window.nvScrollBehavior ? window.nvScrollBehavior() : "smooth") });
      }
    });
  }

  function openTabByTitle(rawTitle) {
    const wanted = normalizeText(rawTitle);
    if (!wanted) return;
    let target = null;
    document.querySelectorAll(".nv-acc-item").forEach((item) => {
      const titleEl = item.querySelector(".nv-acc-title");
      if (!target && titleEl && normalizeText(titleEl.textContent).includes(wanted)) {
        target = item;
      }
    });
    // Ingen flik med den titeln: öppna första fliken (Beskrivning) i stället
    if (!target) target = document.querySelector(".nv-acc-item");
    if (!target) {
      const root = document.querySelector("[data-nv-product-tabs]");
      if (root) root.scrollIntoView({ behavior: (window.nvScrollBehavior ? window.nvScrollBehavior() : "smooth"), block: "start" });
      return;
    }
    openAccordionItem(target);
    scrollTitleToTop(target);
  }

  window.NVProductTabs = window.NVProductTabs || {};
  window.NVProductTabs.openTab = openTabByTitle;

  document.addEventListener("click", function (e) {
    const trigger = e.target.closest("[data-nv-open-tab]");
    if (!trigger) return;
    e.preventDefault();
    openTabByTitle(trigger.getAttribute("data-nv-open-tab"));
  });
})();
